<script setup lang="ts">
import { NavigationMenuLink } from '../navigation-menu'
import { useMediaQuery } from '../utils/use-media-query'

defineProps<{
  url?: string
}>()

const isDesktop = useMediaQuery('md')
</script>

<template>
  <NavigationMenuLink :href="url"
                      :class="['flex focus-visible:outline-offset-[-10px] px-4 py-3 md:px-4 md:py-4 text-button-md font-button gap-1 md:border-none [&:not(:first-child)]:border-t md:[&:not(:first-child)]:border-t-0 md:[&:last-child]:border-b', {'hover:underline hover:underline-offset-2' : isDesktop}]">
    <slot />
  </NavigationMenuLink>
</template>
